<div class="centered-modal-component">
  <div class="close-btn">
    <mat-icon (click)="closeClick()" svgIcon="close-btn"></mat-icon>
  </div>
  <div mat-dialog-title>
      {{ data.title }}
  </div>
  <div mat-dialog-content>
    <span [innerHtml]="data.body">
    </span>
    <mat-icon class="send-icon" svgIcon="send"></mat-icon>
  </div>
</div>